export enum StatusIntegrationQueueEnum {
	Success = 1,
	Error = 2,
	Discarded = 3,
}
